import "./styles.css";
import React, { useState,useEffect } from "react";
import {DisabledPrompt} from "@bcm-dev/bcms-vite";
/**
 * @function UIToggle
 * @param {STRING} dataPoint - Lets us set a dataPoint to the toggle.
 * @return {React.Component}
 * @exported true
 * @description This is a toggle that allows the use to toggle an option on or off.
 * @example
 * <UIToggle />
 */

export default function UIToggle(props) {

  return(
    props.disabledPrompt !== true ? <ToggleContent {...props}/> : <span><DisabledPrompt><ToggleContent {...props}/></DisabledPrompt></span>
  );
}

function ToggleContent(props){
  const dataPoint = props.dataPoint ?{"data-point":props.dataPoint}:{};
  const [ getToggle, setToggle ] = useState(props.checked ?? false);

  const onChange = () => {
    if(props.disabledPrompt !== true) {
      if(props.onChange instanceof Function) {
        props.onChange(!getToggle);
      }

      setToggle(!getToggle);
    }
  }

  useEffect(() => setToggle(props.checked ?? false), [ props.checked ]);
  return (
    <div className="ui-toggle" {...dataPoint}>
      <label className="toggle-switch">
        <input className="toggle-checkbox" type="checkbox" checked={getToggle} onChange={onChange}/>
        <div className="toggle-background"></div>
        <div className="toggle-switch-indicator"></div>
      </label>
    </div>
  );
}